import { audioInitialState } from 'helpers/initialState';

import { AudioState } from './types';

export const AUDIO_INITIAL_STATE: AudioState = {
  audio: audioInitialState,
  playlistName: '',
};